import { Component, HostBinding, inject } from '@angular/core';
import { PageComponent } from './page-component';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';

@Component({ template: '' })
export class DialogComponent extends PageComponent {
    private __matDialog = inject(MatDialog);
    private __matDialogRef = inject(MatDialogRef);
    private __dialogData: { args: any[] } = inject(MAT_DIALOG_DATA);

    @HostBinding('class.dialog-content')
    isDialogContent : boolean = false;

    @HostBinding('class.dialog-page')
    get isDialogPage() : boolean {
        return !this.isDialogContent;
    }

    public init(...args) {

    }

    override fireInit(): void {
        this.initArguments = this.__dialogData.args;
        super.fireInit();
    }

    public showDialog(name : string | any, ...args : any[]) {
        this.shell.showDialog(name, ...args);
    }

    public close() {
        this.__matDialogRef.close();
    }
}